export function mapJsonAssoc(data) {
  //console.log(data);
  data = trimObj(data);
  let map = {};
  let response = data;

  for (var i = 0, l = response.length; i < l; i++) {
    // // Assoc Axits append values / is working - but fix not wanted in frontend but in backend
    // if(map[response[i].name]) {
    //   // let append_map = map[response[i].name].productNames;
    //   // append_map[response[i].name].productNames = [...map[response[i].name].productNames, ...response[i].productNames];
    //   // map = append_map;
    //   if(map[response[i].name].productNames){
    //     let exists = map[response[i].name].productNames;
    //     let append = response[i].productNames;

    //   let append_map = exists.concat(append);
    //   map[response[i].name].productNames = append_map;
    //   console.log("MAP", map[response[i].name]);

    //   }

    // } else {
    map[response[i].name] = response[i];
    //  }
  }
  return map;
}

// Get nested object value
/*
export function getObjectValue(obj, key) {
    return key.split(".").reduce(function(o, x) {
        return (typeof o == "undefined" || o === null) ? o : o[x];
    }, obj);
}
*/

// Trim JSON Objects WEB-1959
export function trimObj(obj) {
  if (obj === null || (!Array.isArray(obj) && typeof obj != "object"))
    return obj;
  return Object.keys(obj).reduce(
    function (acc, key) {
      acc[key.trim()] =
        typeof obj[key] == "string" ? obj[key].trim() : trimObj(obj[key]);
      return acc;
    },
    Array.isArray(obj) ? [] : {}
  );
}

// GET products.json

export function fetchNordJson(dataPath, fetchOptions) {
  let data = fetch(dataPath, fetchOptions)
    .then(function (response) {
      // Get a JSON object from the response
      data = response.json();
    })
    .then(function (jsonData) {
      // Log the data to the console
      console.log("ProductData", data);
      // if(data){
      data = mapJsonAssoc(data);
      //  }
      //  console.log(productsJson);
    })
    .catch(function (error) {
      // if there's an error, log it
      console.error(error);
    });

  return data;
}
